import {Component, Inject, OnInit} from '@angular/core';
import {AppliedMerchantFilters} from "../../../../common/interfaces/AppliedMerchantFilters";
import {MerchantFilters} from "../../../../common/interfaces/MerchantFiltersResponse";
import {AppliedFilters} from "../../../../common/interfaces/AppliedFilters";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';

@Component({
  selector: 'merchant-list-filters-modal',
  templateUrl: './merchant-list-filters-modal.component.html',
  styleUrls: ['./merchant-list-filters-modal.component.scss'],
})
export class MerchantListFiltersModalComponent implements OnInit {

  filters: AppliedMerchantFilters
  loading: boolean = false
  merchantFilters: MerchantFilters

  citiesCheckBoxes: boolean[] = []

  deliveryAreasCheckBoxes: boolean[] = []

  categoriesCheckBoxes: boolean[] = []

  readyWithinCheckBoxes: boolean[] = []

  mealStateCheckBoxes: boolean[] = []

  deliveryAvailableCheckBox: boolean = false

  pickUpAvailableCheckBox: boolean = false

  maxPrice: number = 0
  minPrice: number = 0

  constructor(
    private bottomSheet: MatBottomSheetRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: {
      filters: MerchantFilters,
      appliedFilters: AppliedMerchantFilters
    }
  ) {
  }

  ngOnInit(): void {
    console.log("Received applied Filters", this.data.appliedFilters)
    this.merchantFilters = this.data.filters
    this.filters = this.data.appliedFilters
    this.maxPrice = this.merchantFilters.price.max
    this.minPrice = this.merchantFilters.price.min
  }

  filterResults() {
    this.filters = {
      deliveryAvailable: this.deliveryAvailableCheckBox,
      pickupAvailable: this.pickUpAvailableCheckBox,
      price: {
        from: this.minPrice === this.merchantFilters.price.min ? null : this.minPrice,
        to: this.maxPrice === this.merchantFilters.price.max ? null : this.maxPrice,
      },
      appliedFilters: this.getAppliedFilters()
    }
  }

  getAppliedFilters() {
    let appliedFilters: AppliedFilters[] = []

    let filteredCategories: string[] = []
    for (let i = 0; i < this.categoriesCheckBoxes.length; i++) {
      if (this.categoriesCheckBoxes[i]) {
        filteredCategories.push(this.merchantFilters.categories[i].id)
      }
    }
    appliedFilters.push({
      name: "categoryId",
      filters: filteredCategories
    })

    let filteredAreas: string[] = []
    for (let i = 0; i < this.deliveryAreasCheckBoxes.length; i++) {
      if (this.deliveryAreasCheckBoxes[i]) {
        filteredAreas.push(this.merchantFilters.deliveryAreas[i].id)
      }
    }
    appliedFilters.push({
      name: "areaId",
      filters: filteredAreas
    })

    let filteredCities: string[] = []
    for (let i = 0; i < this.citiesCheckBoxes.length; i++) {
      if (this.citiesCheckBoxes[i]) {
        filteredCities.push(this.merchantFilters.cities[i].id)
      }
    }
    appliedFilters.push({
      name: "cityId",
      filters: filteredCities
    })

    let filteredState: string[] = []
    for (let i = 0; i < this.mealStateCheckBoxes.length; i++) {
      if (this.mealStateCheckBoxes[i]) {
        filteredState.push(this.merchantFilters.state.values[i].id)
      }
    }
    appliedFilters.push({
      name: "state",
      filters: filteredState
    })

    let readyWithin: string[] = []
    for (let i = 0; i < this.readyWithinCheckBoxes.length; i++) {
      if (this.readyWithinCheckBoxes[i]) {
        readyWithin.push(this.merchantFilters.readyWithin.values[i].id)
      }
    }
    appliedFilters.push({
      name: "readyWithin",
      filters: readyWithin
    })

    return appliedFilters
  }

  format(value: number): string {
    return (value / 100).toString()
  }

  onClearCitiesClicked() {
    for (let i = 0; i < this.merchantFilters.cities.length; i++) {
      this.citiesCheckBoxes[i] = false
    }
    this.filterResults()
  }

  onClearDeliveryAreasClicked() {
    for (let i = 0; i < this.merchantFilters.deliveryAreas.length; i++) {
      this.deliveryAreasCheckBoxes[i] = false
    }
    this.filterResults()
  }

  onClearCategoriesClicked() {
    for (let i = 0; i < this.merchantFilters.categories.length; i++) {
      this.categoriesCheckBoxes[i] = false
    }
    this.filterResults()
  }

  onClearCookStateClicked() {
    for (let i = 0; i < this.merchantFilters.state.values.length; i++) {
      this.mealStateCheckBoxes[i] = false
    }
    this.filterResults()
  }

  onClearReadyWithinClicked() {
    for (let i = 0; i < this.merchantFilters.readyWithin.values.length; i++) {
      this.readyWithinCheckBoxes[i] = false
    }
    this.filterResults()
  }

  closeFilters() {
    this.bottomSheet.dismiss(this.filters)
    event?.preventDefault()
  }

  clearFilters() {
    // for (let i = 0; i < this.deliveryAreasCheckBoxes.length; i++) {
    //   this.deliveryAreasCheckBoxes[i] = false
    // }
    //
    // for (let i = 0; i < this.categoriesCheckBoxes.length; i++) {
    //   this.categoriesCheckBoxes[i] = false
    // }
    //
    // for (let i = 0; i < this.citiesCheckBoxes.length; i++) {
    //   this.citiesCheckBoxes[i] = false
    // }
    //
    // for (let i = 0; i < this.readyWithinCheckBoxes.length; i++) {
    //   this.readyWithinCheckBoxes[i] = false
    // }
    //
    // for (let i = 0; i < this.mealStateCheckBoxes.length; i++) {
    //   this.mealStateCheckBoxes[i] = false
    // }
    //
    // this.pickUpAvailableCheckBox = false
    // this.deliveryAvailableCheckBox = false
    //
    // this.minPrice = this.merchantFilters.price.min
    // this.maxPrice = this.merchantFilters.price.max
    // this.getAppliedFilters()
    this.filters = {
      deliveryAvailable: false,
      pickupAvailable: false,
      price: {
        from: null,
        to: null
      },
      appliedFilters: []
    }
    this.applyFilters()
  }

  applyFilters() {
    this.bottomSheet.dismiss(this.filters)
  }

}
